module.exports = __webpack_public_path__ + "img/Frame 134.7b561cb1.png";